<section class="header">
	<h3>Авторы</h3>
	<a routerLink="profile" tkButton>Создать автора</a>
</section>

<cdk-table *ngIf="!(loading$ | async); else loader" [dataSource]="authorList$">
	<cdk-header-row *cdkHeaderRowDef="columns"></cdk-header-row>

	<ng-container cdkColumnDef="avatar">
		<cdk-header-cell *cdkHeaderCellDef> Аватар </cdk-header-cell>

		<cdk-cell *cdkCellDef="let row">
			<tk-avatar [src]="row.avatar" size="30px" class="avatar" />
		</cdk-cell>
	</ng-container>

	<ng-container cdkColumnDef="name">
		<cdk-header-cell *cdkHeaderCellDef> Имя </cdk-header-cell>

		<cdk-cell *cdkCellDef="let row"> {{ row.name }} </cdk-cell>
	</ng-container>

	<ng-container cdkColumnDef="position">
		<cdk-header-cell *cdkHeaderCellDef> Позиция </cdk-header-cell>

		<cdk-cell *cdkCellDef="let row">
			<div class="space-between">
				{{ row.position }}
				<div class="hovered_row--show">
					<button (click)="deleteAuthor($event, row.id)" class="control control--delete">
						<tk-icon icon="trash" />
					</button>
				</div>
			</div>
		</cdk-cell>
	</ng-container>

	<cdk-row *cdkRowDef="let row; columns: columns" (click)="editAuthor(row)" class="pointer"></cdk-row>
</cdk-table>

<ng-template #loader>
	<tk-loader width="FULL"></tk-loader>
</ng-template>
